import { useEffect, useState } from "react";
import { responseMsg } from "../common/ResponseMsg";
import DataChart from "./DataChart";
import moment from 'moment';
import { gridBadgeRender, getStatusGroupColorNew } from "../common/Common";
import Flex from "../../shared/components/Flex";
import { addTooltipField } from "../../shared/utils/gridTitleUtil";
import "./SensorStyle.module.css"
import Card from "../../shared/components/Card";
import Padding from "../../shared/components/Padding";
import Text from "../../shared/components/Text";
import Spacer from "../../shared/components/Spacer";
import useDevice from "../../shared/hooks/useDevice";
import Pill from "../../shared/components/Pill";
import AgGridTable from "../common/AgGridTable";

function DetailComponent(props) {
    const [ selectedSensor, setSelectedSensor] = useState(props.data);
    const [ measurement, setMeasurement ] = useState();
    const [ pagination, setPagination ] = useState();
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const getStatusGroupColor = (data) =>{
        return data ? getStatusGroupColorNew(data).color : "rgba(62, 99, 237, 1)";
    }
  
    const gridBadgeRenderNew = (text,backColor,color) => {
        
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                }}
            >
                <Pill
                    style={{
                        borderRadius: "4px",
                        width: "85px",
                        height: "30px",
                        backgroundColor: backColor,
                    }}
                    border={0}
                    text={<Text color="white" size={14}>{text}</Text>}
                />
            </div>
        
        )
    }

    const apiGetSensorsLog = (page) => {
        const pagingSize = 20;

        if (props.searchProps.interval) {
            const tmp = {...props.searchProps, startDate:moment(props.searchProps.startDate).format("YYYY.MM.DD HH:mm:ss")}

            fetch(`/api/system/sensors/${selectedSensor?.imei}/${tmp.startDate}/${tmp.endDate}?page=${page-1}&size=${pagingSize}`, {
                method: "GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if(json.code === responseMsg.SUCCESS.code) {
                    setMeasurement(json.data.map(ele => {
                        return {
                            ...ele,
                            create_dtm_day:moment(ele.create_dtm).format("YYYY-MM-DD"),
                            create_dtm_time:moment(ele.create_dtm).format("HH:mm"),
                        };
                    }));

                    setPagination(json.pagination);
                }
            })
        }
    }

    // 엑셀 다운로드용 헤더 정의 (한 줄로 평탄화)
    const excelHeaders = [
        { key: 'create_dtm', text: '생성일' },
        { key: 'temp', text: '온도(°C)' },
        { key: 'humidity', text: '습도(%)' },
        { key: 'windSpeed', text: '풍속(m/s)' },
        { key: 'kmaTemp', text: '기상청 온도(°C)' },
        { key: 'kmaHumidity', text: '기상청 습도(%)' },
        { key: 'kmaWindSpeed', text: '기상청 풍속(m/s)' },
        { key: 'avgSpeed', text: '평균속도' },
        { key: 'speed', text: '최고속도' },
        { key: 'status', text: '표출문구' }
    ];

    // gridTable config
    const gridConfig = {
        columnDefs: addTooltipField([
            { headerName: '번호', flex:0.1, minWidth:80, valueGetter: `node.rowIndex + ${pagination && (pagination.currentPageNo - 1) * pagination.recordsPerPage + 1}` },
            { headerName: '생성일', flex:0.1,minWidth:150, field: 'create_dtm', hide:true },
            { headerName: '날짜', flex:0.1,minWidth:150, field: 'create_dtm_day',notExcel:true,},
            { headerName: '시간', flex:0.1,minWidth:100, field: 'create_dtm_time',notExcel:true},
            { headerName: '센서데이터', children: addTooltipField([
                { headerName: '온도(°C)', flex:0.1,minWidth:100, field: 'temp', cellRenderer: (props) => gridBadgeRender(props.value,"white","red")},
                { headerName: '습도(%)', flex:0.1,minWidth:100, field: 'humidity', cellRenderer: (props) => gridBadgeRender(props.value,"white","blue")},
                { headerName: '풍속(m/s)', flex:0.1,minWidth:100, field: 'windSpeed', cellRenderer: (props) => gridBadgeRender(props.value,"white","green")}
            ])},
            { headerName: '기상청데이터', children: addTooltipField([
                { headerName: '온도(°C)', flex:0.1,minWidth:100, field: 'kmaTemp', cellRenderer: (props) => props.value ? gridBadgeRender(props.value,"white","red") : gridBadgeRender("수집중...","white","#a1a1a7e6")},
                { headerName: '습도(%)', flex:0.1,minWidth:100, field: 'kmaHumidity', cellRenderer: (props) =>props.value ? gridBadgeRender(props.value,"white","blue") : gridBadgeRender("수집중...","white","#a1a1a7e6")},
                { headerName: '풍속(m/s)', flex:0.1,minWidth:100, field: 'kmaWindSpeed', cellRenderer: (props) =>props.value ? gridBadgeRender(props.value,"white","green") : gridBadgeRender("수집중...","white","#a1a1a7e6")},
            ])},
            { headerName: '평균속도', flex:0.1,minWidth:100, field: 'avgSpeed',},
            { headerName: '최고속도', flex:0.1,minWidth:100, field: 'speed',},
            { headerName: '표출문구', flex:0.1,minWidth:100, field: 'status', cellRenderer: (props) => gridBadgeRenderNew(props.value, getStatusGroupColor(props.data.statusGroup),"white")}
        ]),
        pagination: true,
        suppressRowHoverHighlight: true,
        rowData: measurement,
    }

    useEffect(() => {
        apiGetSensorsLog(1);
        props.setDetailGrid(gridConfig.columnDefs);
        // 엑셀용 헤더도 함께 전달
        if (props.setExcelHeaders) {
            props.setExcelHeaders(excelHeaders);
        }
    }, [selectedSensor, props.searchProps])

    return (
        <Flex noWrap={true} fullWidth flexDirection="column" gap={10} style={{flex: 1}}>
            { props.customBtnWrap && ( props.customBtnWrap ) }                   
            {
                props.showChart && <DataChart 
                    searchProps={props.searchProps}
                    selectedSensor={selectedSensor}
                />
            }
            {
                !props.showChart && 
                <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                    <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column", height: isMobile ? "400px" : "auto" }}>
                        <Text weight={"bold"}>제품데이터 목록</Text>
                        <Spacer direction='vertical' size={15} />
                        <AgGridTable
                            suppressRowHoverHighlight={true}
                            columnDefs={gridConfig.columnDefs}
                            rowData={gridConfig.rowData}
                            defaultColDef={{
                                sortable: true,
                                resizable: true,
                            }}
                            tooltipShowDelay={0}
                            tooltipHideDelay={2000}
                            onPageChange={apiGetSensorsLog}
                            pagination={pagination}
                        />
                    </Padding>
                </Card>
            }
        </Flex>
    )
}

export default DetailComponent;